import classNames from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'
import { Input } from 'core-components/library/inputs'
import { TRANSLATION_KEYS } from 'partner360/components/trainingCentre/translations'

import styles from './TrainingCentreSearch.module.scss'

interface ITrainingCentreSearchProps {
  value: string
  onChange: (value: string) => void
  onClear: () => void
}

export const TrainingCentreSearch = ({ value, onClear, onChange }: ITrainingCentreSearchProps) => {
  return (
    <Input
      classes={{
        root: styles.search,
      }}
      value={value}
      onChange={onChange}
      label={<Translation text={TRANSLATION_KEYS.search} />}
      endContent={
        <Flex
          className={styles.inputContent}
          alignItems={'center'}
          justifyContent={'center'}
          gap={'sm'}
        >
          <div className={styles.btn} onClick={onClear}>
            <i className={classNames('kbase kbase-close', styles.searchIcon)} />
          </div>
          <i className={classNames('kbase kbase-search', styles.searchIcon)} />
        </Flex>
      }
    />
  )
}
